/**
 * Built-in platform tool names (notifications).
 *
 * Mirrors BuiltInToolConstants in
 * api-agents.api/Domain/ApiAgents.Domain.Notifications/Services/BuiltInToolConstants.cs.
 *
 * The legacy names are kept deliberately: tool names are persisted on ToolExecutionLog and
 * NotificationLog rows, so logs written before the rename still carry them. Dropping them would
 * silently stop the notification badge from rendering on historical logs.
 */
export const NOTIFICATION_TOOL_NAMES: ReadonlySet<string> = new Set([
  "send_email",
  "send_telegram",
  // legacy — pre-rename rows
  "send_email_notification",
  "send_telegram_notification",
]);

/** True when the tool name is a built-in notification tool, current or legacy. */
export const isNotificationTool = (toolName: string): boolean =>
  NOTIFICATION_TOOL_NAMES.has(toolName);
